import React__default, { memo } from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Handle } from './handle.js';
import { Highlight } from './highlight.js';
import { Track } from './track.js';

var _excluded = ["name", "onChange", "value", "minValue", "maxValue", "reverse", "orientation", "stepSize", "variant", "children"];
var Slider = /*#__PURE__*/memo(function (_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
    maxValue = _ref.maxValue,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? "horizontal" : _ref$orientation,
    _ref$stepSize = _ref.stepSize,
    stepSize = _ref$stepSize === void 0 ? 1 : _ref$stepSize,
    variant = _ref.variant,
    children = _ref.children,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Track, _extends({}, restProps, {
    minValue: minValue,
    maxValue: maxValue,
    reverse: reverse,
    orientation: orientation,
    stepSize: stepSize,
    variant: variant,
    onClick: onChange
  }), /*#__PURE__*/React__default.createElement("input", {
    name: name,
    value: value,
    type: "hidden"
  }), /*#__PURE__*/React__default.createElement(Highlight, {
    minValue: minValue,
    start: minValue,
    end: value
  }), /*#__PURE__*/React__default.createElement(Handle, {
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    value: value,
    onChange: onChange
  }), children);
});

export { Slider };
//# sourceMappingURL=slider.js.map
